import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TenantSubscriptionModel } from '../../../../../models/aggregates/tenant-subscription';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionTenantAdminEPService extends BaseApiTemplateService<TenantSubscriptionModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions/tenant-admin-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions/tenant-admin-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions/tenant-admin-ep';
    this.httpClient = http;
  }

  public getByTenantCode(tenantCode: string, visa: ApiVisa): Observable<ApiResponseModel<TenantSubscriptionModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const urlByTenant = this.apiUrl + '/' + tenantCode;
    return this.httpClient.get<ApiResponseModel<TenantSubscriptionModel>>(
      urlByTenant,
      this.getHttpHeader(visa)
    );
  }

  public getByTenanntCriteria(pagination: Pagination, tenantCode: string, visa: ApiVisa): Observable<PagingResponseModel<TenantSubscriptionModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/' + tenantCode + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<TenantSubscriptionModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}

